import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HomeService } from './services/home/home.service';
import { CategoryService } from "./services/category/category.service";
import { ProductService } from "./services/product/product.service";
import { CartService } from "./services/cart/cart.service";
import { UserService } from "./services/user/user.service";
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { AuthInterceptorService } from './services/interceptor/auth-interceptor.service';
import { PanierComponent } from './panier/panier.component';
import { InspirationComponent } from './inspiration/inspiration.component';
import { ProductsComponent } from './products/products.component';
import { AproposComponent } from './apropos/apropos.component';
import { B2bComponent } from './b2b/b2b.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { InfoComponent } from './info/info.component';
import { CommandesComponent } from './commandes/commandes.component';
import { FacturesComponent } from './factures/factures.component';
import { BalancesComponent } from './balances/balances.component';
import { AdressComponent } from './adress/adress.component';
import { RecherchesComponent } from './recherches/recherches.component';
import { RobimedsComponent } from './robimeds/robimeds.component';
import { WalletComponent } from './wallet/wallet.component';
import { ContactComponent } from './contact/contact.component';
import { ConnexionComponent } from './connexion/connexion.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MarquesComponent } from './marques/marques.component';

import {IvyCarouselModule} from 'angular-responsive-carousel';
import { FiltreComponent } from './filtre/filtre.component';

import { FormsModule } from '@angular/forms';

//pagination
import {NgxPaginationModule} from 'ngx-pagination';
import { SearchComponent } from './search/search.component';
import { MarqueComponent } from './marque/marque.component';
import { PanierProductComponent } from './panier-product/panier-product.component';
import { FavorisComponent } from './favoris/favoris.component';
import { CategoryComponent } from './category/category.component';
import { CardProductComponent } from './card-product/card-product.component';
import { DashmenuComponent } from './dashmenu/dashmenu.component';
import { DateformPipe } from './pipes/dateform.pipe';
import { ChartsModule } from "ng2-charts";
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { FactureComponent } from './facture/facture.component';
import { CommandeDetailComponent } from './commande-detail/commande-detail.component';
import { MoncompteComponent } from './moncompte/moncompte.component';
import { B2cCommandeComponent } from './b2c-commande/b2c-commande.component';
import { SeriesComponent } from './series/series.component';
import { SerieComponent } from './serie/serie.component';
import { CgvComponent } from './cgv/cgv.component';
import { PromosComponent } from './promos/promos.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProductDetailComponent,
    PanierComponent,
    InspirationComponent,
    ProductsComponent,
    AproposComponent,
    B2bComponent,
    CheckoutComponent,
    InfoComponent,
    CommandesComponent,
    FacturesComponent,
    BalancesComponent,
    AdressComponent,
    RecherchesComponent,
    RobimedsComponent,
    WalletComponent,
    ContactComponent,
    ConnexionComponent,
    HeaderComponent,
    FooterComponent,
    MarquesComponent,
    FiltreComponent,
    SearchComponent,
    MarqueComponent,
    PanierProductComponent,
    FavorisComponent,
    CategoryComponent,
    CardProductComponent,
    DashmenuComponent,
    DateformPipe,
    ConfirmationComponent,
    FactureComponent,
    CommandeDetailComponent,
    MoncompteComponent,
    B2cCommandeComponent,
    SeriesComponent,
    SerieComponent,
    CgvComponent,
    PromosComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    IvyCarouselModule,
    NgxPaginationModule,
    FormsModule,
    ChartsModule
  ],
  providers: [ HomeService,CategoryService,ProductService,CartService,UserService ,{ provide:HTTP_INTERCEPTORS,useClass:AuthInterceptorService,multi:true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
